function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.043,4.892A15.522,15.522,0,0,0,2.618,23.617l-2.2,8.042L8.643,29.5a15.512,15.512,0,0,0,7.416,1.889h.006a15.526,15.526,0,0,0,10.978-26.5ZM16.065,28.769H16.06a12.882,12.882,0,0,1-6.565-1.8l-.471-.28L4.142,27.972l1.3-4.76-.307-.488a12.9,12.9,0,1,1,10.927,6.045Zm7.075-9.661c-.387-.194-2.294-1.132-2.649-1.261s-.614-.194-.873.194-1,1.262-1.228,1.52-.452.292-.84.1a10.591,10.591,0,0,1-3.118-1.924,11.672,11.672,0,0,1-2.157-2.686c-.226-.389,0-.578.17-.792a10.861,10.861,0,0,0,.969-1.326.711.711,0,0,0-.032-.679c-.1-.194-.872-2.1-1.2-2.88-.315-.755-.635-.653-.873-.665s-.485-.014-.743-.014a1.421,1.421,0,0,0-1.034.486A4.345,4.345,0,0,0,8.18,12.412a7.545,7.545,0,0,0,1.583,4.012c.194.258,2.734,4.175,6.624,5.854A21.91,21.91,0,0,0,18.6,23.1a5.3,5.3,0,0,0,2.442.154,3.991,3.991,0,0,0,2.617-1.844,3.242,3.242,0,0,0,.226-1.844C23.787,19.4,23.528,19.3,23.14,19.108Z",
  fill: "#596975",
  fillRule: "evenodd"
});

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Assets",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.eee33d7f.svg";
export { ForwardRef as ReactComponent };